import axios from "axios";
import React, { useState, useEffect } from "react";
import CreaEquipoUrgencias from "./CreaEquipos/CreaEquipoUrgencias";
import Cookies from "universal-cookie";
import DequipoUrgencias from "../../EliminaEquipos/DequipoUrgencias";

function EquipoUrgencias(props) {
  const cookies = new Cookies();
  const [list, setList] = useState([]);

  const url = window.location.href;
  const partesURL = url.split("/");
  const nombreRuta = partesURL[partesURL.indexOf("#") + 1];

  // 🔹 GET CENTRALIZADO
  const obtenerEquipos = () => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoUrgenciasPorSolicitudId?SolicitudId=" +
        props.idSolicitud,
    })
      .then((res) => setList(res.data))
      .catch(console.log);
  };

  useEffect(() => {
    obtenerEquipos();
  }, [props.idSolicitud]);

  return (
    <div className="container">
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold text-primary">
            1.1. EQUIPO PRIMARIO DE MEJORAMIENTO DE URGENCIAS
          </h6>
        </div>

        <div className="card-body">
          {cookies.get("tipo_Usuario") == 2 &&
            nombreRuta === "ProcesoAutoevaluacion" && (
              <CreaEquipoUrgencias
                idSolicitud={props.idSolicitud}
                onCreated={obtenerEquipos} // ⬅️ CLAVE
              />
            )}

          <div className="table-responsive mt-3">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Nombre</th>
                  <th>Servicio</th>
                  <th>Cargo</th>
                  <th>Líder</th>
                  {nombreRuta === "ProcesoAutoevaluacion" && <th>Eliminar</th>}
                </tr>
              </thead>

              <tbody>
                {list.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="text-center">
                      No hay registros
                    </td>
                  </tr>
                ) : (
                  list.map((item) => (
                    <tr key={item.id}>
                      <td>{item.id}</td>
                      <td>{item.nombre}</td>
                      <td>{item.servicio}</td>
                      <td>{item.cargo}</td>
                      <td>{item.lider}</td>
                      {nombreRuta === "ProcesoAutoevaluacion" && (
                        <td>
                          <DequipoUrgencias
                            id={item.id}
                            onDeleted={obtenerEquipos} // ⬅️ CLAVE
                          />
                        </td>
                      )}
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EquipoUrgencias;
